import config from 'config'

export function install(text) {
  if (config.isAlpha) return
  if (config.isTest) return
  window.onbeforeunload = () => {
    return text
  }
}

export function uninstall() {
  window.onbeforeunload = null
}

export default {
  install,
  uninstall,
}
